import { formatThisAndThatList } from "../common/shared";
import {
  MultilingualArrayStringValue,
  multilingualStringPreview as multilingualArrayStringPreview
} from "../schemas/base/multilingualArrayString";
import {
  MultilingualStringValue,
  multilingualStringPreview as multilingualLegacyStringPreview
} from "../schemas/base/multilingualString";

type PreviewTitleValue = MultilingualStringValue | MultilingualArrayStringValue;

const previewTitle = (title?: PreviewTitleValue) => {
  if (!title) return undefined;

  return title._type === "multilingualArrayString"
    ? multilingualArrayStringPreview(title)
    : multilingualLegacyStringPreview(title);
};

export const contentsTitles = (contents: { title?: PreviewTitleValue }[]) => {
  const titles = (contents || [])
    .map((x) => previewTitle(x.title))
    .filter((x): x is string => !!x);

  return titles.length ? formatThisAndThatList(titles) : undefined;
};
